import { h, Fragment } from "preact";
import { Info } from "../../helpers/icons";

export default function ProductOptionSizeNote({ sizeNote }) {
  if (!sizeNote) return null;

  return (
    <div className="product-options__size-note">
      <Info />
      {sizeNote}
    </div>
  );
}
